export const RNPlayerEvents = {
  Play: 'onPlay',
  Playing: 'onPlaying',
  Paused: 'onPaused',
  Seek: 'onSeek',
  Seeked: 'onSeeked',
  PlaybackFinished: 'onPlaybackFinished',
  PlayerError: 'onPlayerError',
  SourceError: 'SourceError',
  StallStarted: 'onStallStarted',
  StallEnded: 'onStallEnded',
  VideoPlaybackQualityChanged: 'onVideoPlaybackQualityChanged',
  TimeChanged: 'TimeChanged',
  Ready: 'Ready',
} as const;

export const AD_EVENT_STATE_MAP: Record<string, string | undefined> = {
  onAdStarted: 'adStarted',
  onAdFinished: 'adCompleted',
  onAdSkipped: 'adSkipped',
  onAdBreakFinished: 'adAllCompleted',
  onAdError: 'adError',
  onAdClicked: 'adClicked',
  onAdScheduled: 'adRequested',
};

export const DEFAULT_HEARTBEAT_INTERVAL = 10000; // 10 seconds
